import { Component, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideCircleAlert } from '@ng-icons/lucide';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmCardImports } from '@spartan-ng/helm/card';
import { HlmIconImports } from '@spartan-ng/helm/icon';

@Component({
  selector: 'app-item-resume',
  imports: [HlmCardImports, HlmButtonImports, RouterModule, HlmIconImports],
  templateUrl: './item-resume.component.html',
  providers: [provideIcons({ lucideCircleAlert })],
})
export class ItemResumeComponent {
  readonly index = input.required<number>();
  readonly invalid = input.required<boolean>();
}
